import noisePng from "./noise.png";
import noiseAvif from "./noise@20aq.avif";
import { clsx } from "clsx";
import ReactDOM from "react-dom";

/**
 * Noise overlay that stretches to fill its closest positioned ancestor
 */
export function Noise({ priority = false, ...props }: React.ComponentPropsWithRef<"div"> & { priority?: boolean }) {
  if (priority) {
    ReactDOM.preload(noiseAvif.src, { as: "image", type: "image/avif" });
  }

  return (
    <div
      {...props}
      className={clsx(
        "tw-absolute tw-inset-0 tw-mix-blend-overlay",
        // fallback for browsers that don't support image-set
        "tw-bg-[image:var(--noise-png)]",
        // finer noise on high-resolution displays
        "tw-bg-[length:256px] [@media(min-resolution:2x)]:tw-bg-[length:128px]",
        props.className,
      )}
      style={
        {
          "--noise-png": `url(${noisePng.src})`,
          imageRendering: "pixelated",
          // browsers that support image-set will use this
          backgroundImage: `image-set(url(${noiseAvif.src}) type('image/avif'), var(--noise-png) type('image/png'))`,
          ...props.style,
        } as React.CSSProperties
      }
    />
  );
}
